module.exports = __webpack_public_path__ + "static/media/instructivom4.62730fa0.png";